import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const AccountDetailPage = lazy(() =>
  import('@/pages/ads/accounts/detail-page').then((m) => ({ default: m.AccountDetailPage })),
);

export const Route = createFileRoute('/_app/ads/accounts/$id')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:ad-accounts', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <AccountDetailPage />
    </Suspense>
  ),
});
